import React from "react";
import styled from "@emotion/styled";

const Row = styled.div`
  width: 475px;
  margin: 30px auto;
  box-shadow: 0 6px 9px rgba(50, 50, 93, 0.06), 0 2px 5px rgba(0, 0, 0, 0.08),
    inset 0 1px 0 rgb(36, 39, 63);
  border-radius: 4px;
  background-color: rgb(36, 39, 63);
  position: relative;
`;

export default Row;
